// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"2988ca69","453":"31a97297","948":"85c95126"}[chunkId] + ".chunk.js";
};